import React, { useState } from 'react'
import { changePasswordApi, deleteUserApi, getMyPageApi } from '../../api/user'
import { useUserStore } from '../../store/userStore'
import { passwordSchema } from '../../utils/validation/yup/user/userYup'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import Swal from 'sweetalert2'

const MypagePwForm = () => {
	/* zustand */
	const { userInfo, logoutAction } = useUserStore((state) => state)

	/* React-hook-form & ✏️Validation - Yup */
	const schema = passwordSchema
	const {
		register,
		handleSubmit,
		setError,
		formState: { errors },
	} = useForm({
		resolver: yupResolver(schema),
	})

	const onSubmitForm = async (formData) => {
		// API 요청
		try {
			let requestData = formData
			await changePasswordApi(requestData)

			Swal.fire({
				title: '개인정보 수정 성공',
				html: '비밀번호가 변경되었습니다.<br> 다시 로그인 해주세요',
				icon: 'success',
				confirmButtonText: '확인',
			}).then((result) => { if (result.isConfirmed) { logoutAction() } else { logoutAction() } })
			return
		} catch (error) {
			// console.log(error)
			if (error.status === 404) {
				setError('password', {
					type: 'manual', // 오류를 수동으로 설정
					message: '현재 비밀번호가 일치하지 않습니다.', // DB에서 받아온 에러 메시지
				})
				return
			} else {
				Swal.fire({
					title: '개인정보 수정 실패',
					html: '개인정보 수정 처리 도중 에러가 발생했습니다.<br> 에러가 반복되면 관리자에게 문의해 주세요.',
					icon: 'error',
					confirmButtonText: '확인',
				})
				return
			}
		}
	}

	return (
		<form onSubmit={handleSubmit(onSubmitForm)}>
			<div className="row mb-4">
				<div className="col-12">
					<label htmlFor="email" className="form-label">이메일</label>
					<input type="text" id="email" className="form-control"
						defaultValue={userInfo.email}
						readOnly
						disabled
					/>
				</div>
			</div>

			{/* 비밀번호 */}
			<div className="row gy-2">
				<div className="col-sm-12 mb-2">
					<label htmlFor="password" className="form-label">비밀번호 변경</label>
					<input type="password" name="password" id="password"
						className={errors.password ? 'form-control border-danger' : 'form-control'}
						placeholder="현재 비밀번호를 입력해 주세요"
						{...register('password')}
					/>
					{errors.password && (
						<p className="text-small text-danger">{errors.password.message}</p>
					)}
				</div>

				<div className="col-sm-12">
					<input type="password" name="newPassword"
						className={errors.newPassword ? 'form-control border-danger' : 'form-control'}
						placeholder="8자리 이상 새로운 비밀번호를 입력해 주세요"
						{...register('newPassword')}
					/>
					{errors.newPassword && (
						<p className="text-small text-danger">{errors.newPassword.message}</p>
					)}
				</div>
				<div className="col-sm-12">
					<input type="password" name="newPasswordCheck"
						className={
							errors.newPasswordCheck
								? 'form-control border-danger'
								: 'form-control'
						}
						placeholder="새로운 비밀번호를 입력해 주세요"
						{...register('newPasswordCheck')}
					/>
					{errors.newPasswordCheck && (
						<p className="text-small text-danger">{errors.newPasswordCheck.message}</p>
					)}
				</div>
			</div>
			<hr className="my-4" />

			<div>
				<button type="submit" className="w-100 btn btn-primary btn-lg">비밀번호 변경</button>
			</div>
		</form>
	)
}

export default MypagePwForm
